module.exports = __webpack_public_path__ + "img/user-header.6834a9ab.png";